import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'ar', label: 'العربية' },
  { code: 'fr', label: 'Français' },
  { code: 'de', label: 'Deutsch' },
] as const;

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    if (open) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  return (
    <div className="language-switcher" ref={ref}>
      <button
        className="settings-btn"
        onClick={() => setOpen(!open)}
        aria-label="Change language"
        title="Change language"
      >
        <Globe size={20} />
      </button>
      {open && (
        <div className="language-dropdown">
          {LANGUAGES.map(({ code, label }) => (
            <button
              key={code}
              className={`language-option${i18n.language === code ? ' language-option-active' : ''}`}
              onClick={() => { i18n.changeLanguage(code); setOpen(false); }}
            >
              {label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
